import { PrivacyPolicy } from "@policystack/react/policy";
import { createFileRoute } from "@tanstack/react-router";

import { PolicyPageLayout, policyComponents } from "#/components/PolicyPageLayout";
import { Separator } from "#/components/ui/separator";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";

import {
  PolicyUpdatesSection,
  PrivacyContactSection,
  PrivacyDoNotSellSection,
  PrivacySecuritySection,
} from "./-policy.supplements";

export const Route = createFileRoute("/privacy-policy")({
  head: () => documentHead(DOCUMENT_TITLES.privacyPolicy),
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  return (
    <PolicyPageLayout
      eyebrow="Legal"
      title="Privacy policy"
      description="How Daily Wars collects, uses, and protects your personal information."
    >
      <div className="flex flex-col gap-10">
        <PrivacyPolicy components={policyComponents} />
        <Separator />
        <PrivacyDoNotSellSection />
        <PrivacySecuritySection />
        <PrivacyContactSection />
        <PolicyUpdatesSection />
      </div>
    </PolicyPageLayout>
  );
}
